/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'reactstrap';
import { Select, Button, Modal, Divider, Switch, Tag, Form, InputNumber } from 'antd';
import SideMenu from '../../components/SideMenu';
import Loading from '../../components/Loading';
import SupplierGrid from '../../components/grids/SupplierGrid';
import { formatMethodValue } from '../../utils/methodFormatter';
import './SupplierCapabilties.scss';
import Subscription from '../../components/Subscription/Subscription';

export default class SupplierCapabilities extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
      email: PropTypes.string,
      cageCode: PropTypes.string,
      permissions: PropTypes.number,
    }).isRequired,
    supplierSelections: PropTypes.object.isRequired,
    supplierSearchCriteria: PropTypes.object.isRequired,
    supplierSearchMenuSwitch: PropTypes.object.isRequired,
    supplierSearchMenuSelect: PropTypes.object.isRequired,
    supplierSearchMenuCamelCase: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    supplierAggs: PropTypes.object.isRequired,
    supplierHits: PropTypes.number.isRequired,
    deselect: PropTypes.func.isRequired,
    clearAll: PropTypes.func.isRequired,
    downloadCsv: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    supplierList: PropTypes.array.isRequired,
    getSelectedSuppliers: PropTypes.func.isRequired,
    selectAll: PropTypes.number.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    rawSelected: PropTypes.object.isRequired,
    modalOpen: PropTypes.bool.isRequired,
    handleOkRfq: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    newRfq: PropTypes.bool.isRequired,
    selectedRfq: PropTypes.string,
    onRadioChange: PropTypes.func.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    onQuantityChange: PropTypes.func,
    rfqInput: PropTypes.object,
    modalVisible: PropTypes.bool.isRequired,
    closeGModal: PropTypes.func.isRequired,

  };
  static defaultProps = {
    selectedRfq: null,
    onQuantityChange: null,
    rfqInput: null,
  };



  render() {
    const {
      auth,
      supplierSelections,
      supplierSearchCriteria,
      supplierSearchMenuSwitch,
      supplierSearchMenuSelect,
      supplierSearchMenuCamelCase,
      options,
      onChange,
      supplierAggs,
      supplierHits,
      deselect,
      clearAll,
      downloadCsv,
      openModal,
      loading,
      supplierList,
      getSelectedSuppliers,
      selectAll,
      changeSelectAllValue,
      rawSelected,
      modalOpen,
      handleOkRfq,
      closeModal,
      newRfq,
      selectedRfq,
      onRadioChange,
      onSelectChange,
      onQuantityChange,
      rfqInput,
      modalVisible,
      closeGModal,
    } = this.props;

    console.log("supplierSelections", supplierSelections);

    return (
      <Subscription service="Supplier Capabilities" level="ICON Core">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Supplier Capabilities Search Page</title>
          <meta
            name="description"
            content="Search the ICON Portal casting supplier database to locate foundries that manufacture metal castings and parts for the defense industry."
          />
          <meta
            name="keywords"
            content="foundry database, metal casting database, icon portal, defense-related castings"
          />
        </Helmet>

        <Row style={{ flexWrap: 'nowrap', marginRight: 0 }}>
          <Col xs={3} className="nf-account-admin__side-panel">
            <SideMenu
              onChange={onChange}
              supplierAggs={supplierAggs}
              supplierSearchCriteria={supplierSearchCriteria}
              supplierSearchMenuSwitch={supplierSearchMenuSwitch}
              supplierSearchMenuSelect={supplierSearchMenuSelect}
              supplierSearchMenuCamelCase={supplierSearchMenuCamelCase}
            />
          </Col>
          <Col>
            <div className="nf-supplier-search-clear-all">
              {/* First row: Supplier count and tags */}
              <Row style={{ paddingBottom: '6px' }}>
                <Col xs={1} />
                <Col
                  xs={2}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 600,
                    fontSize: '16px',
                  }}
                >
                  {supplierHits} supplier(s) found
                </Col>
                <Col
                  xs={9}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '4px',
                  }}
                >
                  {Object.entries(supplierSelections).map(([filterValue, filterKey]) => {
                    const displayValue = filterKey === 'methods' ? formatMethodValue(filterValue) : filterValue;
                    return (
                      <Tag
                        key={filterValue}
                        closable
                        onClose={() => deselect(filterValue)}
                        style={{
                          whiteSpace: 'normal',
                          height: 'auto',
                          maxWidth: '100%',
                          marginBottom: '4px'
                        }}
                      >
                        {filterKey}: {displayValue}
                      </Tag>
                    );
                  })}
                </Col>
              </Row>
              {/* Second row: Action buttons */}
              <Row style={{ paddingBottom: '6px', paddingTop: '6px' }}>
                <Col xs={1} />
                <Col xs={2} />
                <Col xs={2}>
                  <Button onClick={clearAll} type="primary">
                    Clear All
                  </Button>
                </Col>
                <Col xs={3}>
                  {(auth.role === 'GOVERNMENT_USER' ||
                    auth.role === 'SUPER_ADMIN') && (
                      <Button onClick={downloadCsv} type="primary">
                        Download Results
                      </Button>
                    )}{' '}
                </Col>
                <Col xs={4}>
                  {/*  {this.state.iconMember && this.props.auth.role !== 'GOVERNMENT_USER' && ( */}
                  <Button id="sendRFQ"
                    onClick={openModal}
                    type="primary"
                    style={{
                      background: '#ff7c52',
                      border: '#ff7c52',
                      borderRadius: '6px',
                    }}
                  >
                    Send RFQ
                  </Button>
                  {/* )}   */}
                </Col>
              </Row>
            </div>

            {loading && (
              <Loading text="Finding Suppliers that match your requirements" />
            )}
            {!loading && (
              <SupplierGrid
                suppliers={supplierList}
                getSelectedSuppliers={getSelectedSuppliers}
                selectAll={selectAll}
                changeSelectAllValue={changeSelectAllValue}
                rawSelected={rawSelected}
                iconMember={supplierSearchCriteria.iconMember}
              // foundry={foundry}
              />
            )}
          </Col>
        </Row>
        {/* TODO: probably should break this out to its own component */}
        <Modal
          title="Send RFQ"
          visible={modalOpen}
          onOk={handleOkRfq}
          onCancel={closeModal}
          footer={[
            <Button key="back" onClick={closeModal}>
              Return
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={!newRfq && !selectedRfq}
              onClick={handleOkRfq}
            >
              Proceed
            </Button>,
          ]}
        >
          <Switch onClick={onRadioChange} checked={newRfq} />{' '}
          Create a new RFQ

          {newRfq && (
            <Form layout="vertical" style={{ marginTop: 16 }}>
              <Form.Item label="Quantity">
                <InputNumber
                  style={{ width: '100%' }}
                  placeholder="Enter quantity"
                  value={rfqInput && rfqInput.qty}
                  onChange={(value) => onQuantityChange && onQuantityChange('qty', value)}
                  min={1}
                />
              </Form.Item>
              <Form.Item label="Release Quantity">
                <InputNumber
                  style={{ width: '100%' }}
                  placeholder="Enter release quantity"
                  value={rfqInput && rfqInput.releaseQty}
                  onChange={(value) => onQuantityChange && onQuantityChange('releaseQty', value)}
                  min={1}
                />
              </Form.Item>
            </Form>
          )}

          <Divider plain>Or</Divider>
          <p>Select an Existing RFQ</p>
          <Select
            value={selectedRfq}
            style={{ width: '80%' }}
            onChange={onSelectChange}
            allowClear
          >
            {options}
          </Select>
        </Modal>
        <Modal
          visible={modalVisible}
          title='Warning'
          type='warning'
          style={{ top: '40' }}
          onOk={closeGModal}
          onCancel={closeGModal}
        >
          Government users with RFQ Capabilities must be members of a RFQ Group to submit RFQs. Please contact < a href="mailto:support@nffs.org,support@iconportal.com?Subject=Registration RFQ Group" target="_top"> ICON Support</a > to be added to a RFQ Group if you are an authorized procurement officer.
        </Modal>
      </Subscription>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SupplierCapabilities/SupplierCapabilities.jsx